<script setup lang="ts">
withDefaults(
  defineProps<{
    title: string
    subtitle?: string | null
    hasIconLeft?: boolean
    hasIconRight?: boolean
  }>(),
  {
    subtitle: null,
    hasIconLeft: true,
    hasIconRight: false
  }
)
</script>

<template>
  <div class="flex flex-col">
    <div class="flex items-center justify-center sm:justify-start">
      <span v-if="hasIconLeft" class="mr-2 h-6 w-6 rounded-sm bg-primary p-1 text-white">
        <slot name="icon-left" />
      </span>
      <h3 class="text-lg font-semibold text-foreground">
        {{ $t(title) }}
      </h3>
      <span v-if="hasIconRight" class="ml-2">
        <slot name="icon-right" />
      </span>
    </div>
    <p v-if="subtitle" class="mt-1 text-center text-sm font-light text-muted-foreground sm:text-left">
      {{ $t(subtitle) }}
    </p>
  </div>
</template>
